import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type UiState = {
  locale: 'es' | 'en';
  setLocale: (locale: 'es' | 'en') => void;
};

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      locale: 'es',
      setLocale: (locale) => set({ locale }),
    }),
    { name: 'parking-ui' },
  ),
);
